TrelloPerf = require('app/common/debug/perf').default
PerfKeys = TrelloPerf.Keys
isPossiblyValidOrgName = require('app/common/lib/util/is-possibly-valid-org-name').default
Queries = require 'app/scripts/network/quick-queries'

parseJSON = (data) ->
  try
    window.JSON.parse(data)
  catch e
    return null

ajaxGetJSON = (url, next) ->
  xhr = new XMLHttpRequest()
  xhr.open('GET', url, true)
  xhr.setRequestHeader('Accept', 'application/json,text/plain')
  xhr.setRequestHeader('X-Trello-Client-Version', window.trelloVersion || 'dev-0')
  xhr.onreadystatechange = ->
    if xhr.readyState == 4
      if xhr.status != 200
        next([xhr.status, xhr.responseText])
      else
        next(null, [parseJSON(xhr.responseText), xhr])

    return

  xhr.send(null)
  return

makeUrl = (path, query = {}) ->
  invitationTokens = []

  inviteRegex = /invite-token-[-a-f0-9]*=([^;]+)/g

  while (token = inviteRegex.exec(document.cookie)?[1])?
    invitationTokens.push(unescape(token))

  if invitationTokens.length > 0
    # Note that this behavior should match what we're doing in model-loader,
    # where invitationTokens are added after everything else
    query.invitationTokens = invitationTokens.join(',')

  if ///^ /1/search (/|$) ///.test(path)
    dsc = /dsc=([^;]+)/.exec(document.cookie)?[1]
    query.dsc = dsc

  queryString = ([key, encodeURIComponent(value)].join('=') for key, value of query).join('&')
  [path, queryString].join('?')

# Lets see if there's any data we can pre-load
#
# The goal is to be able to anticipate which data URL we're going to need
# and load it ASAP.
#
# NOTE:
# We only want to avoid the *first* time that data URL gets loaded in the future,
# after that we'll load it fresh
preloads = {}

path = location.pathname.substr(1)

getDataUrls = ->
  if path == ""
  # we've come directly to trello.com, so load the data for the member boards page
    [{ key: PerfKeys.QL_MEMBER_BOARDS, url: makeUrl('/1/Members/me', Queries.memberBoards) }]
  else if (search = ///^/([^/]*) ///.exec(path)?[1])?
    search = decodeURIComponent(search).toLowerCase().replace(/[-_ ]+/g, ' ')
    if search
      [
        { key: PerfKeys.QL_MEMBER_QUICK_BOARDS, url: makeUrl('/1/Members/me', Queries.memberQuickBoards) }
        { key: PerfKeys.QL_SEARCH, url: makeUrl('/1/search', Queries.quickBoardsSearch(search)) }
      ]
    else
      [{ key: PerfKeys.QL_MEMBER_QUICK_BOARDS, url: makeUrl('/1/Members/me', Queries.memberQuickBoards) }]
  else if (idBoard = ///^b/([^/]+)///.exec(path)?[1] ? ///^board/[^/]+/([^/]+)///.exec(path)?[1])?
    [
      { key: PerfKeys.QL_BOARD_MIN, url: makeUrl("/1/Boards/#{ idBoard }", Queries.currentBoardMinimal) }
      { key: PerfKeys.QL_BOARD_SECONDARY, url: makeUrl("/1/Boards/#{ idBoard }", Queries.currentBoardSecondary) }
      { key: PerfKeys.QL_BOARD_PLUGINS, url: makeUrl("/1/Boards/#{ idBoard }", Queries.currentBoardPluginData) }
    ]
  else if (idCard = ///^c/([^/]+)///.exec(path)?[1])?
    [{ key: PerfKeys.QL_CARD, url: makeUrl("/1/Cards/#{ idCard }", Queries.card) }]
  else if (orgName = ///^([^/]+)$///.exec(path)?[1])? && isPossiblyValidOrgName(orgName)
    [{ key: PerfKeys.QL_ORGS, url: makeUrl("/1/Organizations/#{ orgName }", Queries.organizationBoardsPage) }]
  else
    []

removePreload = (url) ->
  if url !of preloads
    return
  delete preloads[url]

preload = ({ key, url }) ->
  return if !url
  TrelloPerf.startMeasurement key
  preloadObject =
    isLoading: true
    callbacks: []
    start: Date.now()
    used: false
    url: url
  preloads[url] = preloadObject

  ajaxGetJSON url, (err, data) ->
    preloadObject.isLoading = false
    if err
      preloadObject.error = err
      for callback in preloadObject.callbacks
        callback(err)
      return
    preloadObject.data = data
    TrelloPerf.stopMeasurement key
    for callback in preloadObject.callbacks
      callback(null, data)
    # If the request isn't made within 10 seconds, it'll have to be made again
    setTimeout (-> removePreload(url)), 10000
    return

  return

cleanPreload = (preload) ->
  cleaned = {}
  for key in ['isLoading', 'start', 'used', 'url']
    cleaned[key] = preload[key]
  cleaned

init = ->
  if /token/.test(document.cookie)
    memberUrl = { key: PerfKeys.QL_MEMBER_HEADER, url: makeUrl('/1/Members/me', Queries.memberHeader) }
    for item in [memberUrl].concat(getDataUrls())
      preload(item)
  return

quickload =
  # The "init" method is called once from index.ejs to kick off preloading
  init: init
  makeUrl: makeUrl
  load: (url, next) ->
    preloadObject = preloads[url]
    if preloadObject?
      preloadObject.used = true
      if preloadObject.isLoading
        preloadObject.callbacks.push(next)
      else
        next(preloadObject.error, preloadObject.data)
        removePreload(url)
      return cleanPreload(preloadObject)
    else
      ajaxGetJSON url, next
    return

  clear: ->
    for url of preloads
      removePreload(url)
    return

module.exports = window.QuickLoad = quickload
